(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.factory('launcherService', function ($http) {

        var svc = {};

        return svc;
    });

    fmgApp.factory('accountManagementService', function($http,app_env, authenticationService) {

        var acctMgtService;
        acctMgtService = {};

        acctMgtService.setPassword = function(authCode,newPassword){
            var payload = {};
            payload.Code = authCode;
            payload.NewPassword = newPassword;

            //Secure Post
            return $http.post(app_env.baseUrl+'AUTH/api/authentication/setpassword',payload,authenticationService.getAuthHeader());
        };
        acctMgtService.changePassword = function(oldPassword,newPassword){
            var payload = {};
            payload.OldPassword = oldPassword;
            payload.NewPassword = newPassword;

            //Secure Post
            return $http.post(app_env.baseUrl+'AUTH/api/authentication/changepassword',payload,authenticationService.getAuthHeader());
        };
        acctMgtService.initForgotPassword = function(emailAddress,tenantId){
            var payload = {
                Email : emailAddress,
                Tenant: tenantId
            };
            return $http.post(app_env.baseUrl+'AUTH/v2/logon/forgottenpassword',payload);
        };



        return acctMgtService;
    });

}) (window.angular);